<template>
  <div class="flex-shrink-0 p-2 py-4">
    <router-link :to="chooseFood ? `/submit-order/menu/${subMenu.id}` : `/menu/${subMenu.id}`"
                 class="bg-white rounded-lg px-2 py-1">
      {{ subMenu.subMenu_Name }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: "SubMenuCard",
  props: ['subMenu'],
  data() {
    return {
      chooseFood: false
    }
  },
  created() {
    if (this.$route.matched.some(record => record.name === 'ChooseFood')) {
      this.chooseFood = true
    }
  }
}
</script>

<style scoped>

</style>